import { Controller } from "stimulus";

export default class extends Controller {
  static targets = [
    "marketCapFilter", "volumeFilter", "priceChangeFilter", "priceFilter", "categoryFilter", "exchangeFilter", "platformFilter",
  ];

  handleSearch(e) {
    const url = new URL(e.currentTarget.dataset.url);

    if (this.marketCapFilterTarget.value) {
      url.searchParams.set("filter_market_cap", this.marketCapFilterTarget.value);
    }

    if (this.volumeFilterTarget.value) {
      url.searchParams.set("filter_24h_volume", this.volumeFilterTarget.value);
    }

    if (this.priceChangeFilterTarget.value) {
      url.searchParams.set("filter_24h_change", this.priceChangeFilterTarget.value);
    }

    if (this.priceFilterTarget.value) {
      url.searchParams.set("filter_price", this.priceFilterTarget.value);
    }

    if (this.categoryFilterTarget.value) {
      url.searchParams.set("filter_category", this.categoryFilterTarget.value);
    }

    if (this.exchangeFilterTarget.value) {
      url.searchParams.set("filter_market", this.exchangeFilterTarget.value);
    }

    if (this.platformFilterTarget.value) {
      url.searchParams.set("filter_asset_platform", this.platformFilterTarget.value);
    }

    window.location.href = url.toString();
  }

  handleReset() {
    this.marketCapFilterTarget.value = null;
    this.volumeFilterTarget.value = null;
    this.priceChangeFilterTarget.value = null;
    this.priceFilterTarget.value = null;
    this.categoryFilterTarget.value = null;
    this.exchangeFilterTarget.value = null;
    this.platformFilterTarget.value = null;
  }
}
